// extracted by mini-css-extract-plugin
module.exports = {"divCentro":"Projetos_divCentro__3AtmN"};